import React from 'react'

const lakeDistrict = {
    id: 'lake-district',
    type: 'post',
    countryId: 'uk',
    title: "Four Days in England's Lake District",
    longDate: 'June 25, 2018',
    month: 'June',
    date: '25',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD5.jpg',
    content: [
        {
            text: (
                <div>We started off our travels with a visit to the U.K. for Peter's cousin Laura's wedding. Laura lives in the north of England, and her wedding on June 2nd was 364 days after our wedding last June 3rd. For our wedding anniversary, Peter's parents sent us to lunch at the famous Sharrow Bay in the Lake District (northwest England), home of the original sticky toffee pudding recipe. I am obsessed with sticky toffee pudding and eat it everywhere I can find it when we visit the U.K., so this was incredibly exciting – and I can report that it did not disappoint! Sharrow Bay is also where Hilary and Alastair celebrated their first few wedding anniversaries, so it was really nice to bring that full circle.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/SharrowBay.jpg',
            detailText: (
                <div>Sharrow Bay; photo credit <a href="http://www.cwherald.com/a/archive/top-hotel-takes-a-newview-on-pampering.450911.html">CW Herald</a>.</div>
            )
        },
        {
            text: (
                <div>When they had first suggested we use our extra time after the wedding to go out to the Lake District, we assumed from the name that it would be full of quaint little lakes and rolling hills. We had no idea that England has mountains, and they are rugged and rocky. In retrospect it makes sense, given that Scotland is definitely rugged and mountainous and the Lake District is pretty close to the border. So, we decided to test out our new backpacks and do some hiking!</div>
            )
        },
        {
            text: (
                <div>On Monday morning after the wedding weekend, we left North Yorkshire and drove across the top of the country. On our way out of Felixkirk, we stopped at the edge of the North York Moors National Park to see what the moors looked like.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/moors.jpg'
        },
        {
            text: (
                <div>They were surprisingly flat and grim. You can see how Cathy got lost wandering while grieving over Heathcliff and came down with hypothermia (at least, I'm guessing that's how she got sick. Back then women just 'became weak' from their 'poor constitutions'.)</div>
            )
        },
        {
            text: (
                <div>The Lake District is quite large, so we decided to stay close to Grasmere. We stayed at the Great Langdale campsite for the first two nights, in a teepee with a fireplace inside. Fancy camping!</div>
            )
        },
        {
            text: (
                <div>On our second day, we walked from the campsite up to Stickle Tarn (a tarn is a lake.) The four-hour hike was surprisingly difficult, and the sun beat down on us. The local hikers told us it was unusual to have such hot weather even for June, so we got really lucky. At the top, we sat panting and eating pork pies (the best backpacking food, ever), and looked out at incredible views.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD2.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD3.jpg'
        },
        {
            text: (
                <div>On the third and fourth days, we did an overnight hike in the Fairfield area so we could see more of the scenery. We packed lightly with lunch and snacks from the campsite store and a change of clothes, and left our car outside a hostel in Grasmere. We climbed up to Grisedale Tarn, skirted Fairfield peak, and headed downhill to the Helvellyn youth hostel to stay the night.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD4.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD7.jpg'
        },
        {
            text: (
                <div>At the front desk of the hostel, the manager asked if we were under or over 25. It struck as a weird question until we saw the makeup of the rest of the guests – we were the youngest by about three decades! It seems that the youth hostels in the countryside and hiking areas of England have been co-opted by retirees. They are definitely more expensive than other hostels we've been to, though not much different for the beds, bathrooms etc. Apparently, there are some public service programs trying to convince young people to spend their weekends in nature instead of at the city pubs.</div>
            )
        },
        {
            text: (
                <div>My guess for one reason young people don't travel out of the cities frequently is the high cost of transportation in England. The trains are extremely expensive; we looked into taking them from York to the Lake District then back down to West Sussex via England, and it would have cost hundreds of dollars plus the difficulty of taking infrequent local busses around Grasmere. We were lucky to be able to borrow one of the Liveseys' cars; it wouldn't have been financially feasible to do this trip otherwise.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD6.jpg'
        },
        {
            text: (
                <div>On the way back from the hostel to Grasmere, we went up to Helvellyn and down the other side. This route contains one of the most famous hike sections in England: Striding Edge. An incredibly narrow and rocky ridge with sharp sides sloping hundreds of feet down, Striding Edge can be difficult and even deadly in bad weather. Every year, people attempt it when there's snow cover, slip, and fall.</div>
            )
        },
        {
            text: (
                <div>There's quite a bit of climbing involved, which the Brits call "scrambling" (also, they call hiking "walking.") I went along the top where it's possible to, but there's also a flatter trail that hugs the edge for people who don't like heights (*cough* – Peter.) It's definitely a cool experience.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD8.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD9.jpg'
        },
        {
            text: (
                <div>We were using the Lake District as a warm up to the longer backpacking treks we had planned for later that summer – <a href="/post/laugavegur">Laugavegur</a> and <a href="/post/hiking-tour-du-mont-blanc">Tour du Mont Blanc</a>. After three days of more mountains than we'd bargained for, we were exhausted! Luckily we had a couple weeks ahead of us in England to exercise and undo our couch potato ways. Also, it was time to devour more pork pies and sticky toffee pudding.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/LD10.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/uk/lakedistrict/1989-2.jpg',
            detailText: 'Hilary and Alastair in 1989, and at their wedding anniversary at Sharrow Bay.'
        },
    ]
}


export default lakeDistrict


// WEBPACK FOOTER //
// ./src/Posts/Content/LakeDistrict.js